export const useStringUtils = () => {
    const capitalize = (str: string): string => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const getAvatarLetters = (name: string | undefined) => {
        if (!name) return '';
        const names = name.split(' ');
        if (names.length === 0) return '';
        if (names.length === 1) return names[0].charAt(0).toUpperCase();
        return names[0].charAt(0).toUpperCase() + names[names.length - 1].charAt(0).toUpperCase();
    }

    const minutesToMask = (minutes: string | number | undefined): string => {
        if (minutes === undefined || minutes === null || isNaN(Number(minutes))) return '';
        const mins = Math.floor(typeof minutes === 'string' ? parseFloat(minutes) : minutes);
        const hrs = Math.floor(mins / 60);
        const remMins = mins % 60;
        const paddedHrs = hrs.toString().padStart(2, '0');
        const paddedMins = remMins.toString().padStart(2, '0');
        return `${paddedHrs}:${paddedMins}`;
    }

    const minutesToHuman = (minutes: string | number | undefined): string => {
        if (minutes === undefined || minutes === null || isNaN(Number(minutes))) return '';
        //formato 01 h e 30 minutos || 04 h e 05 minutos || 01 h || 30 minutos
        const mins = Math.floor(typeof minutes === 'string' ? parseFloat(minutes) : minutes);
        const hrs = Math.floor(mins / 60);
        const remMins = mins % 60;
        let result = '';
        if (hrs > 0) {
            result += `${hrs.toString().padStart(2, '0')} h`;
        }
        if (remMins > 0) {
            if (result) result += ' e ';
            result += `${remMins.toString().padStart(2, '0')} minutos`;
        }
        return result;
    }

    const minutesFromMask = (time: string): string => {
        if(!time) return '0';
        const [hrs, mins] = time.split(':').map(part => parseInt(part, 10));
        if(isNaN(hrs) || isNaN(mins)) return '0';
        return String((hrs * 60) + mins);
    }

    return {
        capitalize,
        getAvatarLetters,
        minutesToMask,
        minutesFromMask,
        minutesToHuman,
    };
}